export default [
  {
    benchmark: "Studiekeuze",
    companies: [
      {
        name: "UvA",
        main_brand_color: "#CC0000",
        website: "https://www.uva.nl",
      },
      {
        name: "TU Delft",
        main_brand_color: "#00A6D6",
        website: "https://www.tudelft.nl",
      },
      {
        name: "Erasmus",
        main_brand_color: "#006F54",
        website: "https://www.eur.nl",
      },
      { name: "UU", main_brand_color: "#FFCD00", website: "https://www.uu.nl" },
      {
        name: "Leiden Univestity",
        main_brand_color: "#001A72",
        website: "https://www.universiteitleiden.nl",
      },
      {
        name: "Rijksuniversiteit Groningen",
        main_brand_color: "#CC0000",
        website: "https://www.rug.nl",
      },
      {
        name: "VU amsterdam",
        main_brand_color: "#00A6D6",
        website: "https://www.vu.nl",
      },
      {
        name: "Wageningen University",
        main_brand_color: "#34B233",
        website: "https://www.wur.nl",
      },
      {
        name: "Tilburg University",
        main_brand_color: "#003B7A",
        website: "https://www.tilburguniversity.edu",
      },
      {
        name: "Maastricht University",
        main_brand_color: "#001C3D",
        website: "https://www.maastrichtuniversity.nl",
      },
      {
        name: "Avans",
        main_brand_color: "#E60028",
        website: "https://www.avans.nl",
      },
      {
        name: "HAN",
        main_brand_color: "#E6002E",
        website: "https://www.han.nl",
      },
      {
        name: "HvA",
        main_brand_color: "#25167A",
        website: "https://www.hva.nl",
      },
      { name: "HU", main_brand_color: "#E5002D", website: "https://www.hu.nl" },
      {
        name: "Hogeschool Rotterdam",
        main_brand_color: "#E2001A",
        website: "https://www.hogeschoolrotterdam.nl",
      },
      {
        name: "Fontys",
        main_brand_color: "#6F1D8C",
        website: "https://www.fontys.nl",
      },
    ],
  },
  {
    benchmark: "Energie",
    companies: [
      {
        name: "Eneco",
        main_brand_color: "#E1007E",
        website: "https://www.eneco.nl",
      },
      {
        name: "Essent",
        main_brand_color: "#E6007E",
        website: "https://www.essent.nl",
      },
      {
        name: "Vattenfall",
        main_brand_color: "#2071B5",
        website: "https://www.vattenfall.nl",
      },
      {
        name: "Greenchoice",
        main_brand_color: "#2BB673",
        website: "https://www.greenchoice.nl",
      },
      {
        name: "Oxxio",
        main_brand_color: "#00A4E0",
        website: "https://www.oxxio.nl",
      },
      {
        name: "Budget Thuis",
        main_brand_color: "#00A859",
        website: "https://www.budgetthuis.nl",
      },
      {
        name: "Energiedirect.nl",
        main_brand_color: "#78BE20",
        website: "https://www.energiedirect.nl",
      },
      {
        name: "Vandebron",
        main_brand_color: "#1DB954",
        website: "https://vandebron.nl",
      },
      {
        name: "Pure energie",
        main_brand_color: "#00A651",
        website: "https://pure-energie.nl",
      },
      {
        name: "UnitedConsumers",
        main_brand_color: "#EC1C24",
        website: "https://www.unitedconsumers.com",
      },
      {
        name: "Engie",
        main_brand_color: "#00AEEF",
        website: "https://www.engie.nl",
      },
      {
        name: "Coolblue Energie",
        main_brand_color: "#FF6A00",
        website: "https://www.coolblue.nl/energie",
      },
      {
        name: "Frank Energie",
        main_brand_color: "#00FF5A",
        website: "https://frankenergie.nl",
      },
      {
        name: "Alliander",
        main_brand_color: "#6E2C91",
        website: "https://www.alliander.com",
      },
    ],
  },
  {
    benchmark: "Boodschappen",
    companies: [
      { name: "AH", main_brand_color: "#179EDA", website: "https://www.ah.nl" },
      {
        name: "Jumbo",
        main_brand_color: "#FFD200",
        website: "https://www.jumbo.com",
      },
      {
        name: "Picnic",
        main_brand_color: "#E60012",
        website: "https://www.picnic.nl",
      },
      {
        name: "Plus",
        main_brand_color: "#7FB232",
        website: "https://www.plus.nl",
      },
      {
        name: "COOP",
        main_brand_color: "#F3792E",
        website: "https://www.coop.nl",
      },
      {
        name: "Dirk",
        main_brand_color: "#E30613",
        website: "https://www.dirk.nl",
      },
      {
        name: "Hoogvliet",
        main_brand_color: "#00A0E2",
        website: "https://www.hoogvliet.com",
      },
      {
        name: "SPAR",
        main_brand_color: "#157946",
        website: "https://www.spar.nl",
      },
      {
        name: "Crisp",
        main_brand_color: "#BEDB7C",
        website: "https://crisp.nl",
      },
      {
        name: "Flink",
        main_brand_color: "#FF0AA2",
        website: "https://www.goflink.com",
      },
      {
        name: "Getit",
        main_brand_color: "#5C3CBB",
        website: "https://getir.com",
      },
      {
        name: "Gorillas",
        main_brand_color: "#000000",
        website: "https://gorillas.io",
      },
      {
        name: "HelloFresh",
        main_brand_color: "#98C21F",
        website: "https://www.hellofresh.nl",
      },
    ],
  },
  {
    benchmark: "Zorgverzekering",
    companies: [
      {
        name: "Zilveren Kruis",
        main_brand_color: "#0095DB",
        website: "https://www.zilverenkruis.nl",
      },
      {
        name: "FBTO",
        main_brand_color: "#00A1E9",
        website: "https://www.fbto.nl",
      },
      {
        name: "VGZ",
        main_brand_color: "#00A651",
        website: "https://www.vgz.nl",
      },
      { name: "CZ", main_brand_color: "#A3002A", website: "https://www.cz.nl" },
      {
        name: "Menzis",
        main_brand_color: "#003399",
        website: "https://www.menzis.nl",
      },
      {
        name: "OHRA",
        main_brand_color: "#0047BB",
        website: "https://www.ohra.nl",
      },
      {
        name: "ONVZ",
        main_brand_color: "#FF6A00",
        website: "https://www.onvz.nl",
      },
      {
        name: "DSW",
        main_brand_color: "#215732",
        website: "https://www.dsw.nl",
      },
      {
        name: "a.s.r.",
        main_brand_color: "#000000",
        website: "https://www.asr.nl",
      },
      {
        name: "Zorg & Zekerheid",
        main_brand_color: "#00A1E9",
        website: "https://www.zorgenzekerheid.nl",
      },
      {
        name: "Salland",
        main_brand_color: "#B0002A",
        website: "https://www.salland.nl",
      },
    ],
  },
  {
    benchmark: "Bankzaken",
    companies: [
      {
        name: "ING",
        main_brand_color: "#FF6200",
        website: "https://www.ing.nl",
      },
      {
        name: "Rabobank",
        main_brand_color: "#2C3696",
        website: "https://www.rabobank.nl",
      },
      {
        name: "ABN AMRO",
        main_brand_color: "#009488",
        website: "https://www.abnamro.nl",
      },
      {
        name: "SNS Bank",
        main_brand_color: "#5B2D90",
        website: "https://www.snsbank.nl",
      },
      {
        name: "ASN Bank",
        main_brand_color: "#F54B38",
        website: "https://www.asnbank.nl",
      },
      {
        name: "Regiobank",
        main_brand_color: "#CF000C",
        website: "https://www.regiobank.nl",
      },
      {
        name: "Triodos",
        main_brand_color: "#001069",
        website: "https://www.triodos.nl",
      },
      {
        name: "Bunq",
        main_brand_color: "#010503",
        website: "https://www.bunq.com",
      },
      {
        name: "Knab",
        main_brand_color: "#3E4A59",
        website: "https://www.knab.nl",
      },
      {
        name: "Revolut",
        main_brand_color: "#0075EB",
        website: "https://www.revolut.com",
      },
      { name: "N26", main_brand_color: "#1D1D1B", website: "https://n26.com" },
      {
        name: "Wise",
        main_brand_color: "#163300",
        website: "https://wise.com",
      },
      {
        name: "van Lanschot",
        main_brand_color: "#006341",
        website: "https://www.vanlanschotkempen.com",
      },
      {
        name: "Mollie",
        main_brand_color: "#0092FF",
        website: "https://www.mollie.com",
      },
    ],
  },
  {
    benchmark: "Internet & televisie",
    companies: [
      {
        name: "KPN",
        main_brand_color: "#00C300",
        website: "https://www.kpn.com",
      },
      {
        name: "Ziggo",
        main_brand_color: "#F48D01",
        website: "https://www.ziggo.nl",
      },
      {
        name: "Odido",
        main_brand_color: "#FF00A8",
        website: "https://www.odido.nl",
      },
      {
        name: "Youfone",
        main_brand_color: "#3C104A",
        website: "https://www.youfone.nl",
      },
      {
        name: "Budget Alles-in-1",
        main_brand_color: "#00A651",
        website: "https://www.budgetthuis.nl",
      },
      {
        name: "Delta",
        main_brand_color: "#009FE3",
        website: "https://www.delta.nl",
      },
      {
        name: "Caiway",
        main_brand_color: "#00AEEF",
        website: "https://www.caiway.nl",
      },
      {
        name: "Solcon",
        main_brand_color: "#004B93",
        website: "https://www.solcon.nl",
      },
      {
        name: "Freedominternet",
        main_brand_color: "#E30013",
        website: "https://www.freedom.nl",
      },
      {
        name: "Online.nl",
        main_brand_color: "#00AEEF",
        website: "https://www.online.nl",
      },
      {
        name: "Delta Fiber NL",
        main_brand_color: "#003D79",
        website: "https://www.deltafiber.nl",
      },
    ],
  },
  {
    benchmark: "Track & Trace",
    companies: [
      {
        name: "PostNL",
        main_brand_color: "#FB6200",
        website: "https://www.postnl.nl",
      },
      {
        name: "DHL",
        main_brand_color: "#FFCC00",
        website: "https://www.dhl.com",
      },
      {
        name: "DPD",
        main_brand_color: "#BB0033",
        website: "https://www.dpd.com",
      },
      {
        name: "UPS",
        main_brand_color: "#351C15",
        website: "https://www.ups.com",
      },
      {
        name: "FedEx",
        main_brand_color: "#660099",
        website: "https://www.fedex.com",
      },
      {
        name: "GLS",
        main_brand_color: "#1C156D",
        website: "https://gls-group.com",
      },
      {
        name: "Budbee",
        main_brand_color: "#00D66C",
        website: "https://www.budbee.com",
      },
      {
        name: "Homerr",
        main_brand_color: "#00A9A7",
        website: "https://www.homerr.com",
      },
      {
        name: "Trunkrs",
        main_brand_color: "#00C8B3",
        website: "https://trunkrs.nl",
      },
      {
        name: "Cycloon",
        main_brand_color: "#8DC63F",
        website: "https://www.cycloon.eu",
      },
      {
        name: "Instabox",
        main_brand_color: "#FF1D21",
        website: "https://instabee.com",
      },
    ],
  },

  {
    benchmark: "Kleding",
    companies: [
      {
        name: "debijenkorf.nl",
        main_brand_color: "#FFCC00",
        website: "https://www.debijenkorf.nl",
      },
      {
        name: "wehkamp.nl",
        main_brand_color: "#E60028",
        website: "https://www.wehkamp.nl",
      },
      {
        name: "omoda.nl",
        main_brand_color: "#000000",
        website: "https://www.omoda.nl",
      },
      {
        name: "hunkemoller.nl",
        main_brand_color: "#1A171B",
        website: "https://www.hunkemoller.nl",
      },
      {
        name: "g-star.com",
        main_brand_color: "#000000",
        website: "https://www.g-star.com",
      },
      {
        name: "scotch-soda.com",
        main_brand_color: "#000000",
        website: "https://www.scotch-soda.com",
      },
      {
        name: "suitsupply.com",
        main_brand_color: "#000000",
        website: "https://suitsupply.com",
      },
      {
        name: "zalando.nl",
        main_brand_color: "#FF6900",
        website: "https://www.zalando.nl",
      },
      {
        name: "hema.nl",
        main_brand_color: "#EE0000",
        website: "https://www.hema.nl",
      },
      {
        name: "wefashion.com",
        main_brand_color: "#000000",
        website: "https://www.wefashion.com",
      },
      {
        name: "AboutYou.nl",
        main_brand_color: "#000000",
        website: "https://www.aboutyou.nl",
      },
      {
        name: "C-and-a.com",
        main_brand_color: "#0D1A7B",
        website: "https://www.c-and-a.com",
      },
    ],
  },
  {
    benchmark: "Vakantie boeken",
    companies: [
      {
        name: "TUI Nederland",
        main_brand_color: "#D40E14",
        website: "https://www.tui.nl",
      },
      {
        name: "Corendon",
        main_brand_color: "#D51317",
        website: "https://www.corendon.nl",
      },
      {
        name: "Sunweb",
        main_brand_color: "#ED1C24",
        website: "https://www.sunweb.nl",
      },
      {
        name: "Prijsvrij",
        main_brand_color: "#00A6D6",
        website: "https://www.prijsvrij.nl",
      },
      {
        name: "D-Reizen",
        main_brand_color: "#F47A24",
        website: "https://www.d-reizen.nl",
      },
      {
        name: "ANWB Reizen",
        main_brand_color: "#005AA9",
        website: "https://www.anwb.nl/vakantie",
      },
      {
        name: "VakantieDiscounter",
        main_brand_color: "#FFD400",
        website: "https://www.vakantiediscounter.nl",
      },
      {
        name: "Oad",
        main_brand_color: "#FFD512",
        website: "https://www.oad.nl",
      },
      {
        name: "De Jong Intra",
        main_brand_color: "#0055A5",
        website: "https://www.dejongintra.nl",
      },
      {
        name: "Kras",
        main_brand_color: "#E30613",
        website: "https://www.krasbusreizen.nl",
      },
      {
        name: "Sawadee",
        main_brand_color: "#00A86B",
        website: "https://www.sawadee.nl",
      },
    ],
  },
  {
    benchmark: "Eten bezorgen",
    companies: [
      {
        name: "Thuisbezorgd.nl",
        main_brand_color: "#FF8000",
        website: "https://www.thuisbezorgd.nl",
      },
      {
        name: "Uber Eats",
        main_brand_color: "#06C167",
        website: "https://www.ubereats.com",
      },
      {
        name: "Dominos",
        main_brand_color: "#006491",
        website: "https://www.dominos.nl",
      },
      {
        name: "New York Pizza",
        main_brand_color: "#007A33",
        website: "https://www.newyorkpizza.nl",
      },
      {
        name: "Papa Johns",
        main_brand_color: "#D6001D",
        website: "https://www.papajohns.nl",
      },
      {
        name: "Smullers Delivery",
        main_brand_color: "#009EDB",
        website: "https://www.smullers.nl",
      },
      {
        name: "Five guys delivery",
        main_brand_color: "#C92027",
        website: "https://www.fiveguys.nl",
      },
      {
        name: "Burger King Delivery",
        main_brand_color: "#D62300",
        website: "https://www.burgerking.nl",
      },
      {
        name: "Subway Delivery",
        main_brand_color: "#1E5B2C",
        website: "https://www.subway.com",
      },
      {
        name: "Deliveroo",
        main_brand_color: "#00CCBC",
        website: "https://www.deliveroo.nl",
      },
    ],
  },

  {
    benchmark: "Private lease",
    companies: [
      {
        name: "JustLease",
        main_brand_color: "#FF6A00",
        website: "https://justlease.nl",
      },
      {
        name: "DirectLease",
        main_brand_color: "#EB5B00",
        website: "https://directlease.nl",
      },
      {
        name: "ANWB",
        main_brand_color: "#005AA9",
        website: "https://www.anwb.nl",
      },
      {
        name: "Leaseplan",
        main_brand_color: "#ED8B00",
        website: "https://www.leaseplan.com",
      },
      {
        name: "Athlon",
        main_brand_color: "#003DA5",
        website: "https://www.athlon.com/nl/",
      },
      {
        name: "ALD Automotive",
        main_brand_color: "#0D3646",
        website: "https://www.ayvens.com/nl-nl/",
      },
      {
        name: "Arval",
        main_brand_color: "#00925B",
        website: "https://www.arval.nl",
      },
      {
        name: "Alphabet",
        main_brand_color: "#003399",
        website: "https://www.alphabet.com/nl-nl",
      },
      {
        name: "Privatelease.com",
        main_brand_color: "#FF6A00",
        website: "https://www.privatelease.com",
      },
    ],
  },
  {
    benchmark: "Doe-het-zelf",
    companies: [
      {
        name: "Gamma",
        main_brand_color: "#003B7A",
        website: "https://www.gamma.nl",
      },
      {
        name: "Karwei",
        main_brand_color: "#000000",
        website: "https://www.karwei.nl",
      },
      {
        name: "Praxis",
        main_brand_color: "#FFED00",
        website: "https://www.praxis.nl",
      },
      {
        name: "Hubo",
        main_brand_color: "#FFD100",
        website: "https://www.hubo.nl",
      },
      {
        name: "Hornbach NL",
        main_brand_color: "#F99D27",
        website: "https://www.hornbach.nl",
      },
      {
        name: "Bauhaus NL",
        main_brand_color: "#E30613",
        website: "https://www.bauhaus.nl",
      },
      {
        name: "KlusWijs",
        main_brand_color: "#005BBB",
        website: "https://www.kluswijs.nl",
      },
      {
        name: "Isero",
        main_brand_color: "#009639",
        website: "https://www.isero.nl",
      },
      {
        name: "Multimate",
        main_brand_color: "#003A8C",
        website: "https://www.multimate.nl",
      },
      {
        name: "Fixet",
        main_brand_color: "#F39200",
        website: "https://www.fixet.nl",
      },
      {
        name: "Bouwmaat",
        main_brand_color: "#0033A0",
        website: "https://www.bouwmaat.nl",
      },
    ],
  },
  {
    benchmark: "Ticket",
    companies: [
      {
        name: "Ticketmaster",
        main_brand_color: "#00B2E2",
        website: "https://www.ticketmaster.com",
      },
      {
        name: "Eventim",
        main_brand_color: "#001A72",
        website: "https://www.eventim.de",
      },
      {
        name: "SeeTickets",
        main_brand_color: "#000000",
        website: "https://www.seetickets.com",
      },
      {
        name: "Paylogic",
        main_brand_color: "#FF6600",
        website: "https://www.paylogic.com",
      },
      {
        name: "Ticketswap",
        main_brand_color: "#1B6AFF",
        website: "https://www.ticketswap.nl",
      },
      {
        name: "Ticketpoint",
        main_brand_color: "#FF6A00",
        website: "https://ticketpoint.nl",
      },
      {
        name: "GUTS tickets",
        main_brand_color: "#00C2A8",
        website: "https://guts.tickets",
      },
      {
        name: "Ticketscript",
        main_brand_color: "#E5007D",
        website: "https://www.ticketscript.com",
      },
      {
        name: "Eventbrite",
        main_brand_color: "#F05537",
        website: "https://www.eventbrite.com",
      },
      {
        name: "Universe",
        main_brand_color: "#4F3FB6",
        website: "https://www.universe.com",
      },
      {
        name: "Ticketflow",
        main_brand_color: "#1E63EE",
        website: "https://www.ticketflow.eu",
      },
    ],
  },

  {
    benchmark: "Autoverzekering",
    companies: [
      {
        name: "Interpolis",
        main_brand_color: "#00B5B8",
        website: "https://www.interpolis.nl",
      },
      {
        name: "Centraal Beheer",
        main_brand_color: "#30B457",
        website: "https://www.centraalbeheer.nl",
      },
      {
        name: "FBTO",
        main_brand_color: "#00A1E9",
        website: "https://www.fbto.nl",
      },
      {
        name: "Univé",
        main_brand_color: "#00BD5D",
        website: "https://www.unive.nl",
      },
      {
        name: "OHRA",
        main_brand_color: "#0047BB",
        website: "https://www.ohra.nl",
      },
      {
        name: "Allianz Direct",
        main_brand_color: "#004A94",
        website: "https://www.allianzdirect.nl",
      },
      {
        name: "InShared",
        main_brand_color: "#E5007D",
        website: "https://www.inshared.nl",
      },
      {
        name: "Ditzo",
        main_brand_color: "#00A3E0",
        website: "https://www.ditzo.nl",
      },
      {
        name: "ANWB",
        main_brand_color: "#FFD200",
        website: "https://www.anwb.nl/verzekeringen/autoverzekering",
      },
      {
        name: "Aegon",
        main_brand_color: "#1E4598",
        website: "https://www.aegon.nl",
      },
      {
        name: "Nationale-Nederlanden",
        main_brand_color: "#FF6200",
        website: "https://www.nn.nl",
      },
    ],
  },
  {
    benchmark: "Electronica",
    companies: [
      {
        name: "Coolblue",
        main_brand_color: "#FF5E00",
        website: "https://www.coolblue.nl",
      },
      {
        name: "BOL",
        main_brand_color: "#3366CA",
        website: "https://www.bol.com",
      },
      {
        name: "MediaMarkt",
        main_brand_color: "#E71D2A",
        website: "https://www.mediamarkt.nl",
      },
      {
        name: "BCC",
        main_brand_color: "#66CC00",
        website: "https://www.bcc.nl",
      },
      {
        name: "Alternate",
        main_brand_color: "#E30613",
        website: "https://www.alternate.nl",
      },
      {
        name: "Informatique",
        main_brand_color: "#0033A0",
        website: "https://www.informatique.nl",
      },
      {
        name: "Paradigit",
        main_brand_color: "#00AEEF",
        website: "https://www.paradigit.nl",
      },
      {
        name: "Azerty",
        main_brand_color: "#E4002B",
        website: "https://www.azerty.nl",
      },
      {
        name: "Amazon",
        main_brand_color: "#FF9900",
        website: "https://www.amazon.nl",
      },
      {
        name: "Kamera Express",
        main_brand_color: "#F36C21",
        website: "https://www.kamera-express.nl",
      },
      {
        name: "Art & Craft",
        main_brand_color: "#00A859",
        website: "https://www.artandcraft.com/nl-nl/",
      },
    ],
  },
  {
    benchmark: "Auto & Scooter sharing",
    companies: [
      {
        name: "Felyx",
        main_brand_color: "#005B41",
        website: "https://felyx.com/nl",
      },
      {
        name: "Go Sharing",
        main_brand_color: "#00A651",
        website: "https://go-sharing.nl",
      },
      {
        name: "Check",
        main_brand_color: "#6A1B9A",
        website: "https://ridecheck.app",
      },
      {
        name: "Tier",
        main_brand_color: "#26C2AE",
        website: "https://www.tier.app",
      },
      {
        name: "Lime",
        main_brand_color: "#00DD00",
        website: "https://www.li.me/nl-nl/",
      },
      { name: "Bolt", main_brand_color: "#00D775", website: "https://bolt.eu" },
      {
        name: "Bird",
        main_brand_color: "#000000",
        website: "https://www.bird.co",
      },
      {
        name: "MyWheels",
        main_brand_color: "#00A859",
        website: "https://mywheels.nl",
      },
      {
        name: "Greenwheels",
        main_brand_color: "#C0002E",
        website: "https://www.greenwheels.nl",
      },
      {
        name: "ShareNow",
        main_brand_color: "#0B9BD7",
        website: "https://www.share-now.com/nl/nl/",
      },
      {
        name: "Sixt Share",
        main_brand_color: "#FF5F00",
        website: "https://www.sixt.nl/share/",
      },
      {
        name: "Cargoroo",
        main_brand_color: "#FFD200",
        website: "https://www.cargoroo.nl",
      },
    ],
  },

  {
    benchmark: "Maaltijden",
    companies: [
      {
        name: "HelloFresh",
        main_brand_color: "#98C21F",
        website: "https://www.hellofresh.nl",
      },
      {
        name: "Marley Spoon",
        main_brand_color: "#FFCF00",
        website: "https://marleyspoon.nl",
      },
      {
        name: "Ekomenu",
        main_brand_color: "#29A037",
        website: "https://www.ekomenu.nl",
      },
      {
        name: "Familiebox",
        main_brand_color: "#E31E24",
        website: "https://www.defamiliebox.nl",
      },
      {
        name: "De Krat",
        main_brand_color: "#005AA9",
        website: "https://www.dekrat.nl",
      },
      {
        name: "Streekbox",
        main_brand_color: "#6DBE45",
        website: "https://streekbox.nl",
      },
      {
        name: "Dinnerly",
        main_brand_color: "#5B2AA9",
        website: "https://www.dinnerly.com/nl-nl",
      },
      {
        name: "SimplyCook",
        main_brand_color: "#00A89B",
        website: "https://www.simplycook.com",
      },
      {
        name: "Gousto",
        main_brand_color: "#D62E2E",
        website: "https://www.gousto.co.uk",
      },
      {
        name: "Dinner on the Table",
        main_brand_color: "#00A2AE",
        website: "https://www.dinneronthetable.com.au",
      },
      {
        name: "Plant B",
        main_brand_color: "#00A651",
        website: "https://plantb.nl",
      },
      {
        name: "Green Chef",
        main_brand_color: "#3C9A5F",
        website: "https://www.greenchef.nl",
      },
    ],
  },
  {
    benchmark: "Tweedehands auto's",
    companies: [
      {
        name: "AutoScout24",
        main_brand_color: "#FF7F00",
        website: "https://www.autoscout24.nl",
      },
      {
        name: "Marktplaats Auto",
        main_brand_color: "#FF6A00",
        website: "https://www.marktplaats.nl",
      },
      {
        name: "Gaspedaal.nl",
        main_brand_color: "#F07800",
        website: "https://www.gaspedaal.nl",
      },
      {
        name: "AutoTrack",
        main_brand_color: "#E60023",
        website: "https://www.autotrack.nl",
      },
      {
        name: "AutoTrader.nl",
        main_brand_color: "#E41E26",
        website: "https://www.autotrader.nl",
      },
      {
        name: "ViaBOVAG",
        main_brand_color: "#FFDD00",
        website: "https://www.viabovag.nl",
      },
      {
        name: "AutoHero",
        main_brand_color: "#FF6A00",
        website: "https://www.autohero.nl",
      },
      {
        name: "CarNext",
        main_brand_color: "#FF6A00",
        website: "https://www.carnext.com/nl-nl/",
      },
      {
        name: "Heycar",
        main_brand_color: "#00A499",
        website: "https://www.heycar.nl",
      },
      {
        name: "Bynco",
        main_brand_color: "#0B7BC1",
        website: "https://www.bynco.com/nl",
      },
      {
        name: "Ikwilvanmijnautoaf.nl",
        main_brand_color: "#FF6A00",
        website: "https://www.ikwilvanmijnautoaf.nl",
      },
    ],
  },
  {
    benchmark: "Woning kopen & huren",
    companies: [
      {
        name: "Funda",
        main_brand_color: "#00A6A6",
        website: "https://www.funda.nl",
      },
      {
        name: "Pararius",
        main_brand_color: "#001A72",
        website: "https://www.pararius.nl",
      },
      {
        name: "Jaap.nl",
        main_brand_color: "#FF6A00",
        website: "https://www.jaap.nl",
      },
      {
        name: "Huislijn.nl",
        main_brand_color: "#005AA9",
        website: "https://www.huislijn.nl",
      },
      {
        name: "Huizenzoeker.nl",
        main_brand_color: "#FF6A00",
        website: "https://www.huizenzoeker.nl",
      },
      {
        name: "Koopwoningen.nl",
        main_brand_color: "#F7931E",
        website: "https://www.koopwoningen.nl",
      },
      {
        name: "VBO.nl",
        main_brand_color: "#003A8C",
        website: "https://www.vbo.nl",
      },
      {
        name: "Huurwoningen.nl",
        main_brand_color: "#00A651",
        website: "https://www.huurwoningen.nl",
      },
      {
        name: "Kamernet",
        main_brand_color: "#00A859",
        website: "https://kamernet.nl",
      },
      {
        name: "HousingAnywhere",
        main_brand_color: "#FF6A00",
        website: "https://housinganywhere.com",
      },
      {
        name: "RentSlam",
        main_brand_color: "#8A2BE2",
        website: "https://rentslam.com",
      },
      {
        name: "Idealista (EU)",
        main_brand_color: "#CDE000",
        website: "https://www.idealista.com",
      },
    ],
  },

  {
    benchmark: "Huisdieren",
    companies: [
      {
        name: "Zooplus",
        main_brand_color: "#AFDD87",
        website: "https://www.zooplus.nl",
      },
      {
        name: "PetsPlace.nl",
        main_brand_color: "#E2231A",
        website: "https://www.petsplace.nl",
      },
      {
        name: "Medpets",
        main_brand_color: "#00A67A",
        website: "https://www.medpets.nl",
      },
      {
        name: "Bitiba",
        main_brand_color: "#E30613",
        website: "https://www.bitiba.nl",
      },
      {
        name: "Brekz",
        main_brand_color: "#F58220",
        website: "https://www.brekz.nl",
      },
      {
        name: "Jumper.nl",
        main_brand_color: "#FFD200",
        website: "https://www.jumper.nl",
      },
      {
        name: "Snuffelbox",
        main_brand_color: "#6E2F8A",
        website: "https://snuffelbox.nl",
      },
      {
        name: "PickyPets",
        main_brand_color: "#00A6A6",
        website: "https://picky-pets.com",
      },
      {
        name: "Petfood Expert",
        main_brand_color: "#0A4A8A",
        website: "https://petfood.nl",
      },
      {
        name: "Fuzzy Pet Care",
        main_brand_color: "#00AEEF",
        website: "https://www.dutch.com",
      },
      {
        name: "Eat Small",
        main_brand_color: "#00A86B",
        website: "https://www.fellows.de/eat-small",
      },
      {
        name: "Fellicita",
        main_brand_color: "#E94B35",
        website: "https://www.fellicita.nl",
      },
    ],
  },
  {
    benchmark: "OV ticket & reizen",
    companies: [
      {
        name: "NS (app)",
        main_brand_color: "#FFC917",
        website: "https://www.ns.nl",
      },
      {
        name: "9292",
        main_brand_color: "#000000",
        website: "https://www.9292.nl",
      },
      {
        name: "Tranzer",
        main_brand_color: "#3E2AA5",
        website: "https://tranzer.com",
      },
      {
        name: "OV-pay",
        main_brand_color: "#E5007D",
        website: "https://www.ovpay.nl",
      },
      {
        name: "GVB Reis",
        main_brand_color: "#0863B5",
        website: "https://www.gvb.nl",
      },
      {
        name: "RET App",
        main_brand_color: "#E2001A",
        website: "https://www.ret.nl",
      },
      {
        name: "HTM ReisApp",
        main_brand_color: "#E2001A",
        website: "https://www.htm.nl",
      },
      {
        name: "Arriva App",
        main_brand_color: "#00A19A",
        website: "https://www.arriva.nl",
      },
      {
        name: "Qbuzz App",
        main_brand_color: "#BE1E2D",
        website: "https://www.qbuzz.nl",
      },
      {
        name: "Connexxion Transdev",
        main_brand_color: "#00A859",
        website: "https://www.connexxion.nl",
      },
      {
        name: "Trainline",
        main_brand_color: "#00CC99",
        website: "https://www.thetrainline.com",
      },
      {
        name: "FlixBus",
        main_brand_color: "#73D700",
        website: "https://www.flixbus.nl",
      },
    ],
  },
  {
    benchmark: "E-Bike kopen",
    companies: [
      {
        name: "Gazelle",
        main_brand_color: "#003B7A",
        website: "https://www.gazelle.nl",
      },
      {
        name: "Sparta",
        main_brand_color: "#DE1C39",
        website: "https://www.spartabikes.com/nl-nl",
      },
      {
        name: "Batavus",
        main_brand_color: "#E20613",
        website: "https://www.batavus.nl",
      },
      {
        name: "Koga",
        main_brand_color: "#0071B5",
        website: "https://www.koga.com/nl",
      },
      {
        name: "Cortina",
        main_brand_color: "#5B6D7C",
        website: "https://www.cortinabikes.com/nl",
      },
      {
        name: "VanMoof",
        main_brand_color: "#000000",
        website: "https://www.vanmoof.com/nl-NL",
      },
      {
        name: "Stella",
        main_brand_color: "#5B2AA9",
        website: "https://www.stella.nl",
      },
      {
        name: "Amslod",
        main_brand_color: "#FF6A00",
        website: "https://www.amslod.nl",
      },
      {
        name: "QWIC",
        main_brand_color: "#E22626",
        website: "https://www.qwic.eu/nl",
      },
      {
        name: "BSP",
        main_brand_color: "#0B5CAB",
        website: "https://www.bsp-fietsen.nl",
      },
      {
        name: "Urban Arrow",
        main_brand_color: "#000000",
        website: "https://www.urbanarrow.com",
      },
      {
        name: "Veloretti",
        main_brand_color: "#000000",
        website: "https://www.veloretti.com",
      },
    ],
  },

  {
    benchmark: "Drogist",
    companies: [
      {
        name: "Kruidvat",
        main_brand_color: "#E30613",
        website: "https://www.kruidvat.nl",
      },
      {
        name: "Etos",
        main_brand_color: "#009AA6",
        website: "https://www.etos.nl",
      },
      {
        name: "Trekpleister",
        main_brand_color: "#0076BE",
        website: "https://www.trekpleister.nl",
      },
      {
        name: "Holland & Barrett",
        main_brand_color: "#006341",
        website: "https://www.hollandandbarrett.nl",
      },
      {
        name: "De Online Drogist",
        main_brand_color: "#00A859",
        website: "https://www.deonlinedrogist.nl",
      },
      {
        name: "Plein.nl",
        main_brand_color: "#6E2F8A",
        website: "https://www.plein.nl",
      },
      {
        name: "Drogisterij.net",
        main_brand_color: "#0077C8",
        website: "https://www.drogisterij.net",
      },
      {
        name: "BENU Online Apotheek",
        main_brand_color: "#7BB020",
        website: "https://www.benu.nl",
      },
      {
        name: "Thuisapotheek",
        main_brand_color: "#00A1E9",
        website: "https://www.thuisapotheek.nl",
      },
      {
        name: "Pharmap",
        main_brand_color: "#009E60",
        website: "https://www.pharmamarket.nl",
      },
      {
        name: "Vitstore",
        main_brand_color: "#00A99D",
        website: "https://www.vitstore.com",
      },
    ],
  },
  {
    benchmark: "Bloemen",
    companies: [
      {
        name: "Topbloemen",
        main_brand_color: "#00A651",
        website: "https://www.topbloemen.nl",
      },
      {
        name: "Greetz",
        main_brand_color: "#00C2A8",
        website: "https://www.greetz.nl",
      },
      {
        name: "Fleurop",
        main_brand_color: "#000000",
        website: "https://www.fleurop.nl",
      },
      {
        name: "Bloomon",
        main_brand_color: "#FFDD00",
        website: "https://www.bloomon.nl",
      },
      {
        name: "BloomPost",
        main_brand_color: "#E0007A",
        website: "https://www.bloompost.nl",
      },
      {
        name: "Regiobloemist",
        main_brand_color: "#65B32E",
        website: "https://www.regiobloemist.nl",
      },
      {
        name: "Boeketcadeau",
        main_brand_color: "#E5007D",
        website: "https://www.boeketcadeau.nl",
      },
      {
        name: "Hallmark Bloemen",
        main_brand_color: "#522398",
        website: "https://www.hallmark.nl/bloemen",
      },
      {
        name: "Euroflorist NL",
        main_brand_color: "#6A1B9A",
        website: "https://www.euroflorist.nl",
      },
      {
        name: "Crisp Bloemen",
        main_brand_color: "#BEDB7C",
        website: "https://crisp.nl",
      },
    ],
  },
  {
    benchmark: "Baan zoeken",
    companies: [
      {
        name: "Indeed",
        main_brand_color: "#003A9B",
        website: "https://nl.indeed.com",
      },
      {
        name: "Linkedin Jobs",
        main_brand_color: "#0A66C2",
        website: "https://www.linkedin.com/jobs",
      },
      {
        name: "Glassdoor",
        main_brand_color: "#0CAA41",
        website: "https://www.glassdoor.com",
      },
      {
        name: "Monsterboard",
        main_brand_color: "#6E46AE",
        website: "https://www.monsterboard.nl",
      },
      {
        name: "Nationale vacaturebank",
        main_brand_color: "#FF6A00",
        website: "https://www.nationalevacaturebank.nl",
      },
      {
        name: "Jobbird",
        main_brand_color: "#00B1FF",
        website: "https://www.jobbird.com",
      },
      {
        name: "Stepstone",
        main_brand_color: "#003B95",
        website: "https://www.stepstone.nl",
      },
      {
        name: "Werk.nl",
        main_brand_color: "#0077C8",
        website: "https://www.werk.nl",
      },
      {
        name: "Randstad",
        main_brand_color: "#005EB8",
        website: "https://www.randstad.nl",
      },
      {
        name: "Young Capital",
        main_brand_color: "#FF6A00",
        website: "https://www.youngcapital.nl",
      },
      {
        name: "Jooble",
        main_brand_color: "#1E88E5",
        website: "https://nl.jooble.org",
      },
    ],
  },

  {
    benchmark: "Vakantie park",
    companies: [
      {
        name: "centerparcs.nl",
        main_brand_color: "#00843D",
        website: "https://www.centerparcs.nl",
      },
      {
        name: "landal.nl",
        main_brand_color: "#8DC63F",
        website: "https://www.landal.nl",
      },
      {
        name: "roompot.nl",
        main_brand_color: "#00A19A",
        website: "https://www.roompot.nl",
      },
      {
        name: "europarcs.nl",
        main_brand_color: "#F39200",
        website: "https://www.europarcs.nl",
      },
      {
        name: "topparken.nl",
        main_brand_color: "#003B7A",
        website: "https://www.topparken.nl",
      },
      {
        name: "molecaten.nl",
        main_brand_color: "#003A70",
        website: "https://www.molecaten.nl",
      },
      {
        name: "rcn.nl",
        main_brand_color: "#77BC1F",
        website: "https://www.rcn.nl",
      },
      {
        name: "hofvansaksen.nl",
        main_brand_color: "#1A1A1A",
        website: "https://www.hofvansaksen.nl",
      },
      {
        name: "krim.nl",
        main_brand_color: "#008D36",
        website: "https://www.krim.nl",
      },
      {
        name: "beeksebergen.nl",
        main_brand_color: "#F39200",
        website: "https://www.beeksebergen.nl",
      },
    ],
  },
  {
    benchmark: "Streaming",
    companies: [
      {
        name: "videoland",
        main_brand_color: "#000000",
        website: "https://www.videoland.com/nl",
      },
      {
        name: "netflix",
        main_brand_color: "#E50914",
        website: "https://www.netflix.com",
      },
      {
        name: "Pathé Thuis",
        main_brand_color: "#FFCB05",
        website: "https://www.pathe-thuis.nl",
      },
      {
        name: "NLZiet",
        main_brand_color: "#E60023",
        website: "https://www.nlziet.nl",
      },
      {
        name: "Viaplay",
        main_brand_color: "#CC0336",
        website: "https://viaplay.com",
      },
      {
        name: "NPO Start",
        main_brand_color: "#F36C21",
        website: "https://npo.nl/start",
      },
    ],
  },
];
